<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="quick-title-wrapper">
        <div class="quick-title">{{L.addShipmentDetails}}</div>
      </div>
      <div class="inp-wrapper">
        <div class="inp-wrap">
          <div class="title">{{L.orderID}}:</div>
          <div class="inp">{{obj.contractCode}}</div>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.productNo}}:</div>
          <div class="inp">{{obj.module}}</div>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.platform}}:</div>
          <div class="inp">{{obj.platform}}</div>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.registrated}}:</div>
          <el-checkbox @change="changeRegis" v-model="obj.ifCusSigned"></el-checkbox>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.terminalCustomer}}:</div>
          <el-input v-if="!obj.ifCusSigned" size="mini" class="inp" v-model="obj.customerName"></el-input>
          <el-select v-if="obj.ifCusSigned" filterable clearable class="inp" size="mini" v-model="obj.customerCode" placeholder="Please select">
            <el-option
              v-for="item in ledCustomerList"
              :key="item.finalCustomerNo"
              :label="item.finalCustomerName"
              :value="item.finalCustomerNo">
            </el-option>
          </el-select>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.saleDate}}:</div>
          <el-date-picker
            size="mini"
            class="inp"
            :clearable="true"
            v-model="obj.salesDate"
            value-format="yyyy-MM-dd"
            format="dd-MM-yyyy"
            type="date">
          </el-date-picker>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.quantity}}:</div>
          <AddNumber
            class="inp"
            paddingTopBottom="4px" 
            v-model="obj.qty"
            :step="1"
            @blur="e=>blurQty(e)" 
            @input="e=>changeQty(e)"
            :showAdd="false"
          />
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.unitPrice}}:</div>
          <div class="inp">{{formatMoney(obj.price)}}</div>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.totalAmount}}:</div>
          <div class="inp">{{formatMoney(obj.amount)}}</div>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="btn-wrap" @click="handleConfirm" v-loading="loading">
          <span>{{L.confirm}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api_cart_address,api_led_ship_add} from '@/api/api'
import {postAction} from '@/api/tool'
import AddNumber from '@/components/AddNumber'

export default {
  name:'Add',
  components:{
    AddNumber
  },
  data() {
    return {
      loading:false,
      show:false,
      ledCustomerList:[],
      obj:{
        bodyId:'',
        contractCode:'',
        module:'',
        platform:'',
        ifCusSigned:false,
        customerCode:'',
        customerName:'',
        salesDate:'',
        qty:1,
        price:0,
        amount:0
      }
    }
  },
  methods:{
    getAdress(){
      postAction(api_cart_address).then(res=>{
        this.ledCustomerList=res.finalCustomerList || []
      })
    },
    changeRegis(){
      this.obj.customerCode=''
      this.obj.customerName=''
    },
    open(obj){
      this.obj={
        contractCode:obj.contractCode,
        module:obj.module,
        platform:obj.platform,
        ifCusSigned:false,
        customerCode:'',
        customerName:'',
        salesDate:'',
        qty:1,
        price:obj.price,
        amount:obj.price,
        bodyId:obj.bodyId
      }
      this.getAdress()
      this.show=true
    },
    close(){
      this.show=false
    },
    blurQty(e){
      this.obj.qty=Math.ceil(e)
      this.obj.qty=this.obj.qty>0?this.obj.qty:1
      this.obj.amount=(this.obj.qty*this.obj.price).toFixed(2)
    },
    changeQty(e){
      this.obj.amount=(e*this.obj.price).toFixed(2)
    },
    handleConfirm(){
      if(!this.obj.salesDate){
        this.$message.warning('Please select the sales date')
        return
      }
      if(this.obj.ifCusSigned && !this.obj.customerCode){
        this.$message.warning('Please select the customer')
        return
      }
      if(!this.obj.ifCusSigned && !this.obj.customerName){
        this.$message.warning('Please enter the customer name')
        return
      }
      let params=JSON.parse(JSON.stringify(this.obj))
      params.ifCusSigned=this.obj.ifCusSigned?'Y':'N'
      this.loading=true
      postAction(api_led_ship_add,params).then(()=>{
        this.loading=false
        this.$message.success('Added successfully')
        this.close()
        this.$emit('afterAdd')
      }).catch(()=>{
        this.loading=false
      })
      
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    padding:30px 0;
    border-radius: 2px;
    position: absolute;
    &:extend(.main-box-shadow);
    width:600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .quick-title-wrapper{
      padding:0 40px 20px 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 26px;
      color:@mainColor;
      border-bottom: 1px solid @inpBorderClolr;
      // padding-bottom: 20px;
      // padding-top: 10px;
      .quick-title{
        // background-color: red;
        text-align: center;
      }
    }
    
    .inp-wrapper{
      padding:0 60px;
      .inp-wrap{
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .title{
          font-size: 12px;
          text-align: left;
          width:120px;
          margin-right: 20px;
          color:@inpNumColor;
          // color:red;
        }
        .inp{
          font-size: 13px;
          flex: 1;
          // color:@inpNumColor;
          color:#181818;
        }
      }
    }
    
    .btn-wrapper{
      padding:0 40px;
      .btn-wrap{
        font-size: 12px;
        margin-top: 26px;
        text-align: center;
        width:100%;
        color:#fff;
        background-color: @mainColor;
        padding:8px 6px;
        box-sizing: border-box;
        border:1px solid @mainColor;
        border-radius: 2px;
        &:extend(.transtion-time);
        &:hover{
          cursor: pointer;
          color:@mainColor;
          background-color: #fff;
          &:extend(.transtion-time);
        }
      }
    }
    
  }
}

</style>